import React, { useRef, memo } from 'react'

const HeaderCellMenu = ({ showColumnMenu }) => {
  const menuRef = useRef()

  const onMenuClicked = () => {
    showColumnMenu(menuRef.current)
  }

  return (
    <span
      ref={menuRef}
      onClick={onMenuClicked}
      className='ag-header-icon ag-header-cell-menu-button'
      // aria-hidden='true'
      style={{
        opacity: 1,
        transition: 'opacity 0.2s ease 0s, border 0.2s ease 0s'
      }}
    >
      <span className='ag-icon ag-icon-menu' unselectable='on' />
    </span>
  )
}

export default memo(HeaderCellMenu)
